import { Navigate } from "react-router-dom";

/** Legacy quality route — stoffkartotek lives under HMS/KS. */
export const ChemicalInventoryList = () => (
  <Navigate to="/dashboard/hse-ks/risk/chemical-inventory" replace />
);
